import InnerComponent from '@Components/Production/ManufacturingOrders/ManufacturingOrdersForm';
import orgContainer from '@Components/AppContainer';

const UpdateManufacturingOrderPage = () => ((orgContainer(InnerComponent)));
export default UpdateManufacturingOrderPage;
